import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { AlertNotificationsService } from '../../../../services/alert-notifications.service';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../../auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgotPassword.component.html',
  styleUrls: ['../login.component.scss'],
  standalone: false
})
export class ForgotPasswordComponent {
  emailForm: FormGroup;
  emailSent: boolean = false;
  isLoading = false;

  constructor(private fb: FormBuilder,
    private notificationService: AlertNotificationsService,
    private translate: TranslateService,
    private authService: AuthService,
    private router: Router) {
    this.emailForm = this.fb.group({
      email: ['', [Validators.required, Validators.email, Validators.minLength(6)]]
    });
  }

  async sendEmail() {
    if (this.emailForm.valid) {
      this.isLoading = true;
      try {
        const email = this.emailForm.get('email')?.value;
        await this.authService.requestResetPassword(email);
        this.emailSent = true;
        this.notificationService.success(this.translate.instant("Link succesfully sent to your email."));
      } catch (error) {
        this.emailSent = false;
        this.notificationService.warning(this.translate.instant("Something went wrong. Please try again later."));
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    }
  }

  toHome() {
    this.router.navigate(['/']);
  }

}